var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import cx from 'clsx';
import React, { useEffect, useState, useCallback, Fragment } from 'react';
import { WallModal } from '../WallModal';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography } from '@material-ui/core';
import { CircularProgress, Skeleton } from '@material-ui/core';
import ErrorIcon from '@material-ui/icons/Error';
import { ReactIntl, InitIntl } from '../../helpers/intel';
import { ClientNames } from '../../models';
// ----------------------------------------------------------------------
const magnolia = '#F8F6FF';
const purple = '#824179';
const grayText = '#828282';
const useStyles = makeStyles((theme) => ({
    cont: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        marginTop: theme.spacing(3)
    },
    item: {
        marginRight: theme.spacing(1),
        display: 'flex',
        flexDirection: 'column',
        alignContent: 'center',
        paddingTop: '8px',
        paddingBottom: '8px',
        borderRadius: 3,
        cursor: 'pointer',
        width: '30%',
        maxWidth: '120px',
        '&:hover': {
            backgroundColor: magnolia,
            '& span': {
                color: `${purple} !important`
            }
        }
    },
    normalBorder: {
        border: '1px solid #C8CDD4'
    },
    selectedBorder: {
        backgroundColor: `${magnolia} !important`,
        border: `1px solid ${purple}`,
        '& span': {
            color: purple
        }
    },
    mr: {
        marginRight: '10px'
    },
    mb: {
        marginBottom: '10px'
    },
    totalContainer: {
        justifyContent: 'space-between',
        marginTop: '10px',
        flexDirection: 'row',
        backgroundColor: magnolia,
        padding: '15px',
        borderRadius: 3,
        width: '100%'
    },
    itemsFlexEnd: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end'
    },
    imageBorder: {
        display: 'none',
        width: '46px',
        height: '38px',
        backgroundColor: magnolia,
        borderRadius: '8px',
        marginRight: '10px',
        [theme.breakpoints.up('lg')]: {
            display: 'flex'
        }
    },
    linkDecoration: {
        textDecoration: 'underline !important',
        display: 'block',
        width: '100%',
        textAlign: 'center',
        fontSize: '0.875rem',
        marginTop: '10px'
    },
    textAlign: {
        textAlign: 'center',
        [theme.breakpoints.up('md')]: {
            textAlign: 'left'
        }
    },
    selectHeader: {
        textAlign: 'center',
        [theme.breakpoints.up('md')]: {
            textAlign: 'left'
        }
    },
    unsetPosition: {
        backgroundPosition: 'unset !important'
    },
    lowerCase: {
        textTransform: 'lowercase'
    },
    overlay: {
        width: '100%',
        height: '80px',
        position: 'absolute',
        background: '#fff',
        zIndex: 2,
        opacity: '0.4',
        top: '48px'
    }
}));
export const TopUpAssetsModal = ({ show, onClose, isFreeUser, router, subscription, multiSeatRole, currentLanguage, listTopUpApi, generateCheckoutUrlApi, isLocal, clientName, freeRedirectPath }) => {
    const [intl, setIntl] = useState(InitIntl());
    const fetchIntel = useCallback((lng) => __awaiter(void 0, void 0, void 0, function* () {
        setIntl(yield ReactIntl(lng || 'en', 'top-up-modal'));
    }), []);
    useEffect(() => {
        fetchIntel(currentLanguage);
    }, [currentLanguage]);
    return (React.createElement(React.Fragment, null, show && (React.createElement(TopUpModal, { intl: intl, show: show, onClose: onClose, isFreeUser: isFreeUser, router: router, subscription: subscription, multiSeatRole: multiSeatRole, listTopUpApi: listTopUpApi, generateCheckoutUrlApi: generateCheckoutUrlApi, isLocal: isLocal, clientName: clientName, freeRedirectPath: freeRedirectPath }))));
};
const ImageTopUp = ({ intl, topUpData, selected, handleSelected }) => {
    const classes = useStyles();
    return (React.createElement(Box, { component: 'div', display: 'flex', flexDirection: 'row' },
        React.createElement(Box, { className: classes.imageBorder },
            React.createElement(Box, { component: 'img', src: '/img/imageAssets.svg', width: 20, height: 20, margin: '10px' })),
        React.createElement(Box, { component: 'div', mt: '5px', width: '100%' },
            React.createElement(Typography, { variant: 'h6', mb: '10px', className: classes.selectHeader }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({
                id: 'asset_name_2',
                defaultMessage: 'Images'
            })),
            React.createElement(Typography, { variant: 'subtitle2', className: classes.selectHeader }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({
                id: 'tu_modal_assets_images_select',
                defaultMessage: 'Select the number of images'
            })),
            React.createElement(Box, { className: classes.cont }, topUpData.length === 0 ? (React.createElement(Box, { component: 'div', display: 'flex', flexDirection: 'row' },
                React.createElement(Skeleton, { width: '120px', height: '66px', className: classes.mr }),
                React.createElement(Skeleton, { width: '120px', height: '66px', className: classes.mr }),
                React.createElement(Skeleton, { width: '120px', height: '66px' }))) : (topUpData.map((asset, idx) => (React.createElement(Fragment, { key: idx }, asset.category === '123rf' ? (React.createElement(Box, { onClick: (e) => {
                    e.preventDefault();
                    handleSelected(idx, asset);
                }, className: cx(classes.item, selected === idx
                    ? classes.selectedBorder
                    : classes.normalBorder) },
                React.createElement(Typography, { variant: 'button', align: 'center' }, asset.name.match(/\d/g).join('')),
                React.createElement(Typography, { variant: 'button', align: 'center', color: grayText, className: classes.lowerCase }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({
                    id: 'asset_name_2',
                    defaultMessage: 'Images'
                })))) : ('')))))))));
};
const VideoTopUp = ({ intl, topUpData, selected, handleSelected }) => {
    const classes = useStyles();
    return (React.createElement(Box, { display: 'flex', flexDirection: 'row' },
        React.createElement(Box, { className: classes.imageBorder },
            React.createElement(Box, { component: 'img', src: '/img/videoAssets.svg', width: 20, height: 20, margin: '10px' })),
        React.createElement(Box, { component: 'div', mt: '5px', width: '100%' },
            React.createElement(Typography, { variant: 'h6', className: classes.selectHeader, mb: '10px' }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({
                id: 'asset_name_3',
                defaultMessage: 'Videos'
            })),
            React.createElement(Typography, { variant: 'subtitle2', className: classes.selectHeader }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({
                id: 'tu_modal_assets_videos_select',
                defaultMessage: 'Select the number of videos'
            })),
            React.createElement(Box, { className: classes.cont }, topUpData.length === 0 ? (React.createElement(Box, { component: 'div', display: 'flex', flexDirection: 'row' },
                React.createElement(Skeleton, { width: '120px', height: '66px', className: classes.mr }),
                React.createElement(Skeleton, { width: '120px', height: '66px', className: classes.mr }),
                React.createElement(Skeleton, { width: '120px', height: '66px' }))) : (topUpData.map((asset, idx) => (React.createElement(Fragment, { key: idx }, asset.category === 'getty' ? (React.createElement(Box, { onClick: (e) => {
                    e.preventDefault();
                    handleSelected(idx, asset);
                }, className: cx(classes.item, selected === idx
                    ? classes.selectedBorder
                    : classes.normalBorder) },
                React.createElement(Typography, { variant: 'button', align: 'center' }, asset.name.match(/\d/g).join('')),
                React.createElement(Typography, { variant: 'button', align: 'center', color: 'GrayText', className: classes.lowerCase }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({
                    id: 'asset_name_3',
                    defaultMessage: 'Videos'
                })))) : ('')))))))));
};
const Total = ({ intl, topUpData, val }) => {
    const classes = useStyles();
    return (React.createElement(Box, { component: 'div', display: 'flex', className: classes.totalContainer },
        React.createElement(Typography, { variant: 'h6', align: 'left', display: 'flex', alignItems: 'center' }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({
            id: 'total',
            defaultMessage: 'Total'
        })),
        React.createElement(Box, { component: 'div', className: classes.itemsFlexEnd }, topUpData.length === 0 ? (React.createElement(Box, { component: 'div', className: classes.itemsFlexEnd },
            React.createElement(Skeleton, { width: '95px', height: '28px', className: classes.mb }),
            React.createElement(Skeleton, { width: '166px', height: '22px' }))) : (React.createElement(React.Fragment, null,
            React.createElement(Typography, { variant: 'h6', align: 'left', mb: '10px', display: 'flex', justifyItems: 'center' }, `${val.currency} ${val.price}`),
            React.createElement(Typography
            // className={classes.lowerCase}
            , { 
                // className={classes.lowerCase}
                variant: 'subtitle2', align: 'left', mb: '0', color: grayText }, `${val.currency} ${val.price_per_asset} / ${val.category === 'getty'
                ? intl === null || intl === void 0 ? void 0 : intl.formatMessage({
                    id: 'video',
                    defaultMessage: 'Video'
                })
                : intl === null || intl === void 0 ? void 0 : intl.formatMessage({
                    id: 'image',
                    defaultMessage: 'Image'
                })}`))))));
};
const AssetsSelect = ({ val, setVal, intl, listTopUpApi, isFreeUser, multiSeatRole, setLoading }) => {
    const classes = useStyles();
    const [selected, setSelected] = useState(0);
    const [topUpData, setTopUpData] = useState([]);
    const handleSelected = (key, asset) => {
        setSelected(key);
        setVal(Object.assign(Object.assign({}, val), { currency: asset.currency, price: asset.price, sku: asset.sku, name: asset.name, category: asset.category, price_per_asset: asset.price_per_asset }));
    };
    useEffect(() => {
        function getTopUpList() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    setLoading(true);
                    const response = yield listTopUpApi();
                    setTopUpData(response.data);
                    setVal(response.data[0]);
                }
                catch (error) {
                    console.error(error);
                }
                finally {
                    setLoading(false);
                }
            });
        }
        getTopUpList();
    }, []);
    return (React.createElement(Box, { component: 'div' },
        React.createElement(ImageTopUp, { intl: intl, selected: selected, topUpData: topUpData, handleSelected: handleSelected }),
        React.createElement(Box, { paddingY: '15px' }),
        React.createElement(VideoTopUp, { intl: intl, selected: selected, topUpData: topUpData, handleSelected: handleSelected }),
        React.createElement(Box, { paddingY: '10px' }),
        React.createElement(Total, { intl: intl, topUpData: topUpData, val: val }),
        React.createElement(Box, { paddingY: '10px' }),
        isFreeUser && (React.createElement(Box, { component: 'div', display: 'flex', flexDirection: 'row' },
            React.createElement(ErrorIcon, { color: 'error' }),
            React.createElement(Typography, { variant: 'subtitle2', color: 'error', align: 'left', ml: '10px' }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({
                id: 'tu_modal_image_request',
                defaultMessage: 'You need to be a Pro user to use premium images'
            })))),
        multiSeatRole !== 'Owner' && (React.createElement(Box, { component: 'div', display: 'flex', flexDirection: 'row', position: 'relative' },
            React.createElement(ErrorIcon, { color: 'error' }),
            React.createElement(Typography, { variant: 'subtitle2', color: 'error', align: 'left', ml: '10px' }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({
                id: 'tu_permission',
                defaultMessage: 'You do not have permission to top up premium images.'
            })),
            React.createElement(Box, { component: 'div', className: classes.overlay })))));
};
const TopUpModal = ({ intl, show, onClose, isFreeUser, router, subscription, multiSeatRole, listTopUpApi, generateCheckoutUrlApi, isLocal, clientName, freeRedirectPath }) => {
    const classes = useStyles();
    const [val, setVal] = useState({});
    const [loading, setLoading] = useState(false);
    function checkoutSku() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                setLoading(true);
                const response = yield generateCheckoutUrlApi(val.sku);
                window.location.href = response.data.checkout_url;
            }
            catch (error) {
                setLoading(false);
                console.error(error);
            }
        });
    }
    return (React.createElement(WallModal, { title: ' ', bannerImgUrl: `${isLocal ? 'https://dev.designs.ai' : ''}/img/assets-topup.png`, ctaOnClick: multiSeatRole !== 'Owner'
            ? () => { }
            : !isFreeUser
                ? () => {
                    checkoutSku();
                }
                : () => {
                    if (router) {
                        router.push('/pricing');
                    }
                    else {
                        let url = '';
                        switch (clientName) {
                            case ClientNames.logomaker:
                                url = '/logomaker';
                                break;
                            case ClientNames.videomaker:
                                url = '/videomaker';
                                break;
                            case ClientNames.speechmaker:
                                url = '/speechmaker';
                                break;
                            case ClientNames.designmaker:
                                url = '/designmaker';
                                break;
                            default:
                        }
                        window.location.href = `${isLocal ? 'https://dev.designs.ai' : ''}/pricing${url}${freeRedirectPath ? `?redirect=${freeRedirectPath}` : ''}`;
                    }
                }, show: show, onClose: onClose, ctaText: loading === true ? (React.createElement(CircularProgress, { sx: { zIndex: 3 }, color: 'secondary', size: '16px' })) : multiSeatRole !== 'Owner' ? (intl === null || intl === void 0 ? void 0 : intl.formatMessage({
            id: 'tu_request_permission',
            defaultMessage: 'Request admin to purchase'
        })) : !isFreeUser ? (intl === null || intl === void 0 ? void 0 : intl.formatMessage({
            id: 'pay_now',
            defaultMessage: 'Pay Now'
        })) : (intl === null || intl === void 0 ? void 0 : intl.formatMessage({
            id: 'subscribe',
            defaultMessage: 'Subscribe Now'
        })), header: intl === null || intl === void 0 ? void 0 : intl.formatMessage({
            id: 'tu_modal_title',
            defaultMessage: 'Top up Premium Assets'
        }), description: intl === null || intl === void 0 ? void 0 : intl.formatMessage({
            id: 'tu_modal_description',
            defaultMessage: 'Purchase premium images and videos to create end products with Designs.ai tools.'
        }), customListComponent: React.createElement(AssetsSelect, { val: val, setVal: setVal, intl: intl, listTopUpApi: listTopUpApi, isFreeUser: isFreeUser, multiSeatRole: multiSeatRole, setLoading: setLoading }), subLink: subscription === 'basic' ? '/pricing' : '', subLinkText: subscription === 'basic'
            ? intl === null || intl === void 0 ? void 0 : intl.formatMessage({
                id: 'upgrade_plan',
                defaultMessage: 'Upgrade plan for a better deal'
            })
            : '', subLinkStyle: classes.linkDecoration, alignment: classes.textAlign, overidePosition: classes.unsetPosition, dataLoading: loading }));
};
//# sourceMappingURL=index.js.map